export default __webpack_public_path__ + "d60f1d2.png";